export default __webpack_public_path__ + "static/media/Ripple.20fc5b1a.svg";